var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper-content animated fadeInRight"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"ibox float-e-margins",staticStyle:{"margin-bottom":"30px"}},[_c('promotionList')],1),_c('div',{staticClass:"ibox float-e-margins"},[_c('confirmedList')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }